/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".onboarding-content[_ngcontent-%COMP%]{padding:30px 40px}.modal-body[_ngcontent-%COMP%]{padding:0}.confirm-check[_ngcontent-%COMP%]{margin-top:15px}.modal-footer[_ngcontent-%COMP%]{border-top:1px solid var(--border-color)}"];
export { styles as styles };
